import React from "react";
import { Container, Box, Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";

export default function JeanneBeanneCasty() {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, mb: 6 }}>

        {/* Lien retour */}
         <Link
           to="/ecole/gouvernance"
           style={{
                display: "inline-block",
                background: "#FFD84D",
                color: "#0B2C5F",
                padding: "8px 16px",
                borderRadius: "6px",
                fontWeight: "600",
                textDecoration: "none",
                marginBottom: "20px"
            }}
     >
          ← Retour à la gouvernance
        </Link>

        {/* En-tête profil */}
        <Box sx={{ textAlign: "center", mt: 3, mb: 5 }}>
          <img
            src="/gouvernance/administratrice.jpeg"
            alt="Jeanne Béanne Casty"
            style={{
              width: "240px",
              borderRadius: "14px",
              marginBottom: "20px",
            }}
          />

          <Typography variant="h4" sx={{ fontWeight: 900, color: "#0B2C5F" }}>
            Jeanne Béanne Casty
          </Typography>

          <Typography sx={{ color: "text.secondary", mt: 1 }}>
            Administratrice – École de la Magistrature
          </Typography>

          <Typography sx={{ color: "text.secondary" }}>
            Administration & finances
          </Typography>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Présentation
        </Typography>

        <Typography paragraph>
          Administratrice expérimentée avec plus de 10 ans d'expérience dans la gestion administrative et financière 
          d'institutions publiques haïtiennes, Jeanne Béanne Casty est spécialisée en gestion budgétaire, 
          comptabilité publique et administration des ressources humaines. Elle est titulaire d'une maîtrise en 
          sciences administratives de l'Université d'État d'Haïti et d'un diplôme en comptabilité publique.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Formation académique et perfectionnement
        </Typography>

        <Typography paragraph>
          Sa formation comprend un cursus complet en administration publique avec spécialisation en gestion financière. 
          Elle a suivi des formations avancées en contrôle de gestion et audit administratif à l'École nationale 
          d'administration publique. Elle est certifiée en systèmes de gestion budgétaire et en administration 
          des ressources humaines.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Parcours professionnel
        </Typography>

        <Typography paragraph>
          Avant de rejoindre l'École de la Magistrature, Jeanne Béanne Casty a occupé des postes de responsabilité 
          administrative dans plusieurs ministères haïtiens, où elle a supervisé la gestion budgétaire et administrative 
          de programmes nationaux. Elle a également travaillé comme consultante pour des projets de renforcement 
          institutionnel.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Responsabilités à l'EMA
        </Typography>

        <Typography paragraph>
          L'administratrice gère les ressources humaines, financières et matérielles de l'école. Elle assure le 
          bon fonctionnement des services administratifs et logistiques, supervise la gestion budgétaire et 
          comptable de l'institution, et coordonne les relations avec les fournisseurs et prestataires de services.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: "#0B2C5F", mb: 2 }}>
          Affiliations et engagements
        </Typography>

        <Typography paragraph>
          Elle est membre de l'Association des administrateurs publics d'Haïti et participe activement à des 
          forums sur la modernisation de l'administration publique. Elle contribue également à des programmes 
          de formation en gestion administrative pour les fonctionnaires publics.
        </Typography>
      </Box>
    </Container>
  );
}
